/* eslint-disable react-hooks/exhaustive-deps */
import {
    Button,
    Checkbox,
    createStyles,
    Divider,
    FormControl,
    FormControlLabel,
    FormGroup,
    FormLabel,
    Grid,
    makeStyles,
    Radio,
    RadioGroup,
    Switch,
    TextField,
    Theme,
    Typography
} from '@material-ui/core';
import { FormApi } from 'final-form';
import React, { useEffect, useState } from 'react';
import { Field, Form, FormSpy } from 'react-final-form';
import { SkeletonLoader } from '../../components/loading/SkeletonLoader';
import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonChecked';
import { IAutoCompleteItem } from '../../typings/autoComplete';
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date';
import { Alert } from '@material-ui/lab';
import { KeyboardTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { ReminderSelector } from '../../components/ReminderSelector';
import ScheduleIcon from '@material-ui/icons/Schedule';
import { mainTheme } from '../../Theme';
import MomentUtils from '@date-io/moment';
import { retrieveEnquiryDefaultConfigData, SystemSettingsNamesData, UpdateEnquiryDefaultConfigMutation } from '../FirmSettingConfigurationRepository';
import { showNotification } from '../../App';
import moment from 'moment';
import { client } from '../..';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import { UserFeature, UserFeatureEnum } from '../../types/UserFeature';
import { EmailResponseTemplateSelector } from '../../emailTemplatesConfiguration/selectors/EmailResponseTemplateSelector';
import DialogBox from '../../Dashboard/Component/DialogBox';
import { CollapsibleSectionCard } from '../../components/cards/CollapsibleSectionCard';
import EventIcon from '@material-ui/icons/Event';
import NotificationsActiveIcon from '@material-ui/icons/NotificationsActive';
import AutorenewIcon from '@material-ui/icons/Autorenew';
import NotificationImportantIcon from '@material-ui/icons/NotificationImportant';
import EventAvailableIcon from '@material-ui/icons/EventAvailable';
import PlaylistAddCheckIcon from '@material-ui/icons/PlaylistAddCheck';
import TrackChangesIcon from '@material-ui/icons/TrackChanges';
import ViewColumnIcon from '@material-ui/icons/ViewColumn';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import DesktopWindowsIcon from '@material-ui/icons/DesktopWindows';
import ButtonBase from '@material-ui/core/ButtonBase';
import clsx from 'clsx';

const SECTION_COLOR = '#7c3aed';
const SECTION_BG = '#f5f3ff';

interface PageLayoutOption {
    columnCount: number;
    title: string;
    description: string;
    screenRequirement: string;
    columnLabels: string[];
}

const DEFAULT_PAGE_LAYOUT = 3;

const pageLayoutOptions: PageLayoutOption[] = [
    {
        columnCount: 3,
        title: '3 Columns',
        description: 'Details, Activity and Follow Up (or Matter) are shown side by side. Best for wide screens.',
        screenRequirement: 'Needs a window about 2,000px wide.',
        columnLabels: ['Details', 'Activity', 'Follow Up'],
    },
    {
        columnCount: 2,
        title: '2 Columns',
        description: 'Details, Further Details and Activity share the left column. Follow Up (or Matter) has its own column.',
        screenRequirement: 'Needs about 1,280px or wider.',
        columnLabels: ['Details / Activity', 'Follow Up'],
    },
    {
        columnCount: 1,
        title: '1 Column',
        description: 'All sections sit behind tabs in a single column. Best for smaller screens.',
        screenRequirement: 'Works on any screen.',
        columnLabels: ['Details / Activity / Follow Up'],
    },
];

type DigitalTrackingFieldName =
    | 'ignoreUtmSourceWhenMatchingCampaigns'
    | 'ignoreUtmMediumWhenMatchingCampaigns'
    | 'ignoreUtmCampaignWhenMatchingCampaigns'
    | 'ignoreUtmContentWhenMatchingCampaigns'
    | 'ignoreUtmKeywordWhenMatchingCampaigns';

interface DigitalTrackingParameter {
    fieldName: DigitalTrackingFieldName;
    label: string;
    description: string;
}

const digitalTrackingParameters: DigitalTrackingParameter[] = [
    {
        fieldName: 'ignoreUtmSourceWhenMatchingCampaigns',
        label: 'Source',
        description: 'Where the traffic came from, e.g. google, newsletter',
    },
    {
        fieldName: 'ignoreUtmMediumWhenMatchingCampaigns',
        label: 'Medium',
        description: 'The marketing channel, e.g. cpc, email, social',
    },
    {
        fieldName: 'ignoreUtmCampaignWhenMatchingCampaigns',
        label: 'Campaign',
        description: 'The specific campaign name or promotion',
    },
    {
        fieldName: 'ignoreUtmContentWhenMatchingCampaigns',
        label: 'Content',
        description: 'Which ad or link was clicked, for A/B-tested content',
    },
    {
        fieldName: 'ignoreUtmKeywordWhenMatchingCampaigns',
        label: 'Keyword',
        description: 'The paid search term that was used',
    },
];

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            display: 'flex',
            flex: 1,
            flexFlow: 'column',
            maxWidth: '800px',
        },
        heading: {
            fontSize: theme.typography.pxToRem(15),
            fontWeight: 600,
            color: theme.palette.primary.main
        },
        accordionDetails: {
            flexFlow: 'column',
        },
        radioGroup: {
            flexFlow: 'row wrap',
        },
        formControl: {
            margin: '10px 0',
        },
        optionWrapper: {
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
        },
        optionContainer: {
            flex: 1,
        },
        optionList: {
            display: 'flex',
            alignItems: 'center',
            padding: '10px 0',
            margin: '0 -5px',
            '& > span': {
                margin: '0 5px',
            },
            '& > div': {
                margin: '0 5px',
            }
        },
        actionsRow: {
            display: 'flex',
            justifyContent: 'flex-end',
            gap: theme.spacing(1.5),
            marginTop: theme.spacing(3),
        },
        actionsDivider: {
            marginTop: theme.spacing(3),
        },
        reminderTextField: {
            width: '30%'
        },
        emailTemplateTextField: {
            maxWidth: '400px',
        },
        radioIcon: {
            color: mainTheme.BrandColors.TemplatePrimary
        },
        defaultMeetingLabel: {
            marginTop: '10px',
            marginRight: '10px'
        },
        trackingWarning: {
            marginBottom: theme.spacing(2),
        },
        trackingList: {
            border: `1px solid ${theme.palette.divider}`,
            borderRadius: 8,
            overflow: 'hidden',
        },
        trackingRow: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
            margin: 0,
            padding: theme.spacing(1.5, 2),
            transition: 'background-color 0.15s ease',
            '&:hover': {
                backgroundColor: theme.palette.action.hover,
            },
        },
        trackingRowLabel: {
            flex: 1,
            minWidth: 0,
        },
        trackingRowTitle: {
            fontWeight: 600,
        },
        trackingRowDescription: {
            color: theme.palette.text.secondary,
            marginTop: theme.spacing(0.25),
        },
        pageLayoutInfo: {
            marginBottom: theme.spacing(2),
        },
        pageLayoutOptionList: {
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
            gap: theme.spacing(2),
        },
        pageLayoutOption: {
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'stretch',
            textAlign: 'left',
            padding: theme.spacing(2),
            border: `1px solid ${theme.palette.divider}`,
            borderRadius: 8,
            backgroundColor: theme.palette.background.paper,
            transition: 'box-shadow 0.15s ease, border-color 0.15s ease, transform 0.15s ease',
            '&:hover': {
                boxShadow: '0 4px 18px rgba(0,0,0,0.10)',
                borderColor: theme.palette.primary.light,
                transform: 'translateY(-1px)',
            },
            '@media (prefers-reduced-motion: reduce)': {
                '&:hover': {
                    transform: 'none',
                },
            },
        },
        pageLayoutOptionSelected: {
            borderColor: theme.palette.primary.main,
            boxShadow: `0 0 0 1px ${theme.palette.primary.main}`,
            '&:hover': {
                borderColor: theme.palette.primary.main,
            },
        },
        pageLayoutSelectedIcon: {
            position: 'absolute',
            top: theme.spacing(1),
            right: theme.spacing(1),
            fontSize: 20,
            color: theme.palette.primary.main,
        },
        pageLayoutPreview: {
            display: 'flex',
            gap: theme.spacing(0.75),
            height: 88,
            padding: theme.spacing(0.75),
            marginBottom: theme.spacing(1.5),
            borderRadius: 6,
            backgroundColor: theme.palette.grey[100],
            border: `1px solid ${theme.palette.divider}`,
        },
        pageLayoutPreviewColumn: {
            flex: 1,
            minWidth: 0,
            display: 'flex',
            flexDirection: 'column',
            gap: theme.spacing(0.5),
            padding: theme.spacing(0.75),
            borderRadius: 4,
            backgroundColor: theme.palette.background.paper,
            border: `1px solid ${theme.palette.divider}`,
        },
        pageLayoutPreviewColumnSelected: {
            borderColor: theme.palette.primary.light,
        },
        pageLayoutPreviewLabel: {
            fontSize: theme.typography.pxToRem(10),
            fontWeight: 600,
            lineHeight: 1.2,
            color: theme.palette.text.secondary,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        },
        pageLayoutPreviewLine: {
            height: 6,
            borderRadius: 3,
            backgroundColor: theme.palette.grey[200],
        },
        pageLayoutPreviewLineShort: {
            width: '60%',
        },
        pageLayoutOptionTitle: {
            fontWeight: 600,
        },
        pageLayoutOptionDescription: {
            color: theme.palette.text.secondary,
            marginTop: theme.spacing(0.5),
        },
        pageLayoutScreenRequirement: {
            display: 'flex',
            alignItems: 'center',
            gap: theme.spacing(0.5),
            marginTop: 'auto',
            paddingTop: theme.spacing(1.5),
            color: theme.palette.text.secondary,
            fontWeight: 500,
        },
        pageLayoutScreenRequirementIcon: {
            fontSize: 16,
        },
    })
);

interface FormDialogProps {
    showWarning: boolean;
    isMandatoryFieldChanged?: boolean;
}
interface MandatoryFields {
    isLocationFieldMandatory: boolean;
    isSourceNotesMandatory: boolean;
    isInternalNotesMandatory: boolean;
    isNatureOfEnquiryMandatory: boolean;
    isEventAndCampaignMandatory: boolean;
    isEmailMandatory: boolean;
    isPhoneNumberMandatory: boolean;
    isMobileNumberMandatory: boolean;
    isOtherSideNameMandatory: boolean;
}

interface FormState extends MandatoryFields, FormDialogProps {
    dueDateOption: 'isManualEntry' | 'isCalculatedDays' | 'isCalculatedHours';
    timeOfDay: MaterialUiPickersDate;
    addDays: number;
    addHours: number;
    defaultMeetingLength: MaterialUiPickersDate;
    reminder?: IAutoCompleteItem;
    overdueReminder?: IAutoCompleteItem;
    isSendReminderOnWeekend: boolean;
    isSendInvitationToAssignee: boolean;
    isSendInvitationToEnquirer: boolean;
    isSendReminderOnWeekendForOverDueReminders: boolean;
    
    // unassigned enquiry notification
    periodBeforeFirstUnassignedReminder?: IAutoCompleteItem;
    periodAfterFirstUnassignedReminder?: IAutoCompleteItem;
    isSendFistUnassignedReminderOnWeekends: Boolean;
    isSendUnassignedAfterFirstReminderOnWeekends: Boolean;

    periodMeetingDefaultReminder: IAutoCompleteItem;
    isSendMeetingDefaultReminderEmail: boolean;
    isSendMeetingDefaultReminderSms: boolean;

    // auto follow ups
    autoFollowUpEmailTemplate: IAutoCompleteItem | null;
    pageLayout: number | null;
    isAutoFollowUp: boolean;
    isEmailMandatory: boolean;
    isPhoneNumberMandatory: boolean;
    isMobileNumberMandatory: boolean;

    // digital tracking
    ignoreUtmSourceWhenMatchingCampaigns: boolean;
    ignoreUtmMediumWhenMatchingCampaigns: boolean;
    ignoreUtmCampaignWhenMatchingCampaigns: boolean;
    ignoreUtmContentWhenMatchingCampaigns: boolean;
    ignoreUtmKeywordWhenMatchingCampaigns: boolean;
}
interface EnquiryDefaultTabState {
    isLoading: boolean;
    isFormChanged: boolean;
    onSubmitLoading: boolean;
    initialMandatoryFields: MandatoryFields | null;
}

export default function EnquiryDefaultTab() {

    const classes = useStyles();

    const [state, setState] = useState<EnquiryDefaultTabState>({
        isLoading: true,
        isFormChanged: false,
        onSubmitLoading: false,
        initialMandatoryFields: null
    });

    const mandatoryFieldNames: Array<keyof MandatoryFields> = [
        'isLocationFieldMandatory',
        'isSourceNotesMandatory',
        'isInternalNotesMandatory',
        'isNatureOfEnquiryMandatory',
        'isEventAndCampaignMandatory',
        'isEmailMandatory',
        'isPhoneNumberMandatory',
        'isMobileNumberMandatory',
        'isOtherSideNameMandatory'
    ];

    const [formState, setFormState] = useState<FormState>({
        dueDateOption: 'isManualEntry',
        timeOfDay: null,
        addDays: 0,
        addHours: 0,
        defaultMeetingLength: null,
        reminder: { value: 'None', label: 'None' },
        overdueReminder: { value: 'None', label: 'None' },
        isSendReminderOnWeekend: false,
        isSendInvitationToAssignee: true,
        isSendInvitationToEnquirer: true,
        isSendReminderOnWeekendForOverDueReminders: false,
        isLocationFieldMandatory: false,
        isSendFistUnassignedReminderOnWeekends: false,
        isSendUnassignedAfterFirstReminderOnWeekends: false,
        periodAfterFirstUnassignedReminder: { value: 'None', label: 'None' },
        periodBeforeFirstUnassignedReminder: { value: 'None', label: 'None' },
        isNatureOfEnquiryMandatory: false,
        isOtherSideNameMandatory: false,
        isInternalNotesMandatory: false,
        isEventAndCampaignMandatory: false,
        isSourceNotesMandatory: false,
        periodMeetingDefaultReminder: { value: 'None', label: 'None'},
        isSendMeetingDefaultReminderEmail: false,
        isSendMeetingDefaultReminderSms: false,
        isAutoFollowUp: false,
        autoFollowUpEmailTemplate: null,
        showWarning: false,
        isEmailMandatory: false,
        isPhoneNumberMandatory: false,
        isMobileNumberMandatory: false,
        ignoreUtmSourceWhenMatchingCampaigns: false,
        ignoreUtmMediumWhenMatchingCampaigns: false,
        ignoreUtmCampaignWhenMatchingCampaigns: false,
        ignoreUtmContentWhenMatchingCampaigns: false,
        ignoreUtmKeywordWhenMatchingCampaigns: false,
        pageLayout: DEFAULT_PAGE_LAYOUT
    });

    useEffect(() => {
        fetchData();
    // tslint:disable-next-line: align
    }, []);

    const fetchData = () => {
        retrieveEnquiryDefaultConfigData(
            true,
            // tslint:disable-next-line: no-console
            (data: SystemSettingsNamesData) => onEnquiryDefaultConfigRetrieved(data),
            // tslint:disable-next-line: no-any
            function (reason: any): void {
                showNotification(null, reason, 'error');
            }
        );
    };

    const onEnquiryDefaultConfigRetrieved = (data: SystemSettingsNamesData) => {
        const config = data.settings.systems.enquiryDefaults.config;

        const isTimeTodayValid =  moment(config.timeOfDay, 'hh:mm a').isValid();

        const isDefaultMeetingLengthValid =  moment(config.defaultMeetingLength, 'HH:mm').isValid();

        setFormState((prevFormState) => {

            let dueDateOption: 'isManualEntry' | 'isCalculatedDays' | 'isCalculatedHours' = 'isManualEntry';

            if (config.isCalculatedDays) {
                dueDateOption = 'isCalculatedDays';
            }

            if (config.isCalculatedHours) {
                dueDateOption = 'isCalculatedHours';
            }

            return {
                ...prevFormState,
                dueDateOption,
                timeOfDay: isTimeTodayValid ? moment(config.timeOfDay, 'hh:mm a') : null,
                addDays: config.addDays,
                addHours: config.addHours,
                defaultMeetingLength: isDefaultMeetingLengthValid ? moment(config.defaultMeetingLength, 'hh:mm') : null,
                reminder: config.reminder ? { value: config.reminder, label: config.reminder } : formState.reminder,
                overdueReminder: config.overdueReminder ? { value: config.overdueReminder, label: config.overdueReminder } : formState.overdueReminder,
                isSendReminderOnWeekend: config.isSendReminderOnWeekend,
                isSendInvitationToAssignee: config.isSendInvitationToAssignee,
                isSendInvitationToEnquirer: config.isSendInvitationToEnquirer,
                isSendReminderOnWeekendForOverDueReminders: config.isSendReminderOnWeekendForOverDueReminders,
                isSendFistUnassignedReminderOnWeekends: config.isSendFistUnassignedReminderOnWeekends,
                isSendUnassignedAfterFirstReminderOnWeekends: config.isSendUnassignedAfterFirstReminderOnWeekends,
                periodAfterFirstUnassignedReminder: config.periodAfterFirstUnassignedReminder
                    ? { value: config.periodAfterFirstUnassignedReminder, label: config.periodAfterFirstUnassignedReminder }
                    : formState.periodAfterFirstUnassignedReminder,
                periodBeforeFirstUnassignedReminder: config.periodBeforeFirstUnassignedReminder
                    ? { value: config.periodBeforeFirstUnassignedReminder, label: config.periodBeforeFirstUnassignedReminder }
                    : formState.periodBeforeFirstUnassignedReminder,
                isLocationFieldMandatory: config.isLocationFieldMandatory,
                isNatureOfEnquiryMandatory: config.isNatureOfEnquiryMandatory,
                isInternalNotesMandatory: config.isInternalNotesMandatory,
                isEventAndCampaignMandatory: config.isEventAndCampaignMandatory,
                isSourceNotesMandatory: config.isSourceNotesMandatory,
                isOtherSideNameMandatory: config.isOtherSideNameMandatory,
                periodMeetingDefaultReminder: config.periodMeetingDefaultReminder
                ? { value: config.periodMeetingDefaultReminder, label: config.periodMeetingDefaultReminder }
                : formState.periodMeetingDefaultReminder,
                isSendMeetingDefaultReminderEmail: config.isSendMeetingDefaultReminderEmail,
                isSendMeetingDefaultReminderSms: config.isSendMeetingDefaultReminderSms,
                isAutoFollowUp: config.isAutoFollowUp,
                autoFollowUpEmailTemplate: config.emailTemplateGuid && config.emailTemplateName ? { value: config.emailTemplateGuid, label: config.emailTemplateName } : null,
                isEmailMandatory: config.isEmailMandatory,
                isPhoneNumberMandatory: config.isPhoneNumberMandatory,
                isMobileNumberMandatory: config.isMobileNumberMandatory,
                ignoreUtmSourceWhenMatchingCampaigns: config.ignoreUtmSourceWhenMatchingCampaigns,
                ignoreUtmMediumWhenMatchingCampaigns: config.ignoreUtmMediumWhenMatchingCampaigns,
                ignoreUtmCampaignWhenMatchingCampaigns: config.ignoreUtmCampaignWhenMatchingCampaigns,
                ignoreUtmContentWhenMatchingCampaigns: config.ignoreUtmContentWhenMatchingCampaigns,
                ignoreUtmKeywordWhenMatchingCampaigns: config.ignoreUtmKeywordWhenMatchingCampaigns,
                pageLayout: pageLayoutOptions.some((option) => option.columnCount === config.pageLayout) ? config.pageLayout : DEFAULT_PAGE_LAYOUT
            };
        });

        setState((prevState) => {

            return {
                ...prevState,
                isLoading: false,
                isLocationFieldMandatory: config.isLocationFieldMandatory,
                isSourceNotesMandatory: config.isSourceNotesMandatory,
                isInternalNotesMandatory: config.isInternalNotesMandatory,
                isNatureOfEnquiryMandatory: config.isNatureOfEnquiryMandatory,
                isEventAndCampaignMandatory: config.isEventAndCampaignMandatory,
                isOtherSideNameMandatory: config.isOtherSideNameMandatory,
                isEmailMandatory: config.isEmailMandatory,
                isPhoneNumberMandatory: config.isPhoneNumberMandatory,
                isMobileNumberMandatory: config.isMobileNumberMandatory,
            };
        });

    };

    // tslint:disable-next-line: no-any
    const onFormValueChanged = (changeProps: any) => {
        if (!changeProps.pristine) {
            setState((prevState) => {
                return {
                    ...prevState,
                    isFormChanged: true
                };
            });
        }
    };

    // tslint:disable-next-line: no-any
    // const required = (value: any) => {
    //     return value ? undefined : 'Required';
    // };

    const onReset = (form: FormApi<FormState>) => () => {
        form.setConfig('keepDirtyOnReinitialize', false);
        form.batch(() => {
            form.reset();
        });
        form.setConfig('keepDirtyOnReinitialize', true);
    };

    const onSave = (form: FormApi<FormState>, values: FormState) => {

        // tslint:disable-next-line: no-console
        // console.log('submit', values);
        setState((prevState) => {
            return {
                ...prevState,
                onSubmitLoading: true,
            };
        });

        client
        .mutate({
            mutation: UpdateEnquiryDefaultConfigMutation,
            variables: {
                isManualEntry: values.dueDateOption === 'isManualEntry',
                isCalculatedDays: values.dueDateOption === 'isCalculatedDays',
                isCalculatedHours: values.dueDateOption === 'isCalculatedHours',
                timeOfDay: moment(values.timeOfDay).format('HH:mm'),
                addDays: values.addDays,
                addHours: values.addHours,
                defaultMeetingLength: moment(values.defaultMeetingLength).format('HH:mm'),
                reminder: values.reminder ? values.reminder.value : 'None',
                overdueReminder: values.overdueReminder ? values.overdueReminder.value : 'None',
                isSendReminderOnWeekend: values.isSendReminderOnWeekend,
                isSendInvitationToAssignee: values.isSendInvitationToAssignee,
                isSendInvitationToEnquirer: values.isSendInvitationToEnquirer,
                isSendReminderOnWeekendForOverDueReminders: values.isSendReminderOnWeekendForOverDueReminders,
                isSendFistUnassignedReminderOnWeekends: values.isSendFistUnassignedReminderOnWeekends,
                isSendUnassignedAfterFirstReminderOnWeekends: values.isSendUnassignedAfterFirstReminderOnWeekends,
                periodAfterFirstUnassignedReminder: values.periodAfterFirstUnassignedReminder ? values.periodAfterFirstUnassignedReminder.value : 'None',
                periodBeforeFirstUnassignedReminder: values.periodBeforeFirstUnassignedReminder ? values.periodBeforeFirstUnassignedReminder.value : 'None',
                isLocationFieldMandatory: values.isLocationFieldMandatory,
                isNatureOfEnquiryMandatory: values.isNatureOfEnquiryMandatory,
                isInternalNotesMandatory: values.isInternalNotesMandatory,
                isEventAndCampaignMandatory: values.isEventAndCampaignMandatory,
                isSourceNotesMandatory: values.isSourceNotesMandatory,
                isOtherSideNameMandatory: values.isOtherSideNameMandatory,
                periodMeetingDefaultReminder: values.periodMeetingDefaultReminder ? values.periodMeetingDefaultReminder.value : 'None',
                isSendMeetingDefaultReminderEmail: values.isSendMeetingDefaultReminderEmail,
                isSendMeetingDefaultReminderSms: values.isSendMeetingDefaultReminderSms,
                emailTemplateGuid: values.autoFollowUpEmailTemplate ? values.autoFollowUpEmailTemplate.value : null,
                isAutoFollowUp: values.isAutoFollowUp,
                pageLayout: values.pageLayout,
                isEmailMandatory: values.isEmailMandatory,
                isPhoneNumberMandatory: values.isPhoneNumberMandatory,
                isMobileNumberMandatory: values.isMobileNumberMandatory,
                ignoreUtmSourceWhenMatchingCampaigns: values.ignoreUtmSourceWhenMatchingCampaigns,
                ignoreUtmMediumWhenMatchingCampaigns: values.ignoreUtmMediumWhenMatchingCampaigns,
                ignoreUtmCampaignWhenMatchingCampaigns: values.ignoreUtmCampaignWhenMatchingCampaigns,
                ignoreUtmContentWhenMatchingCampaigns: values.ignoreUtmContentWhenMatchingCampaigns,
                ignoreUtmKeywordWhenMatchingCampaigns: values.ignoreUtmKeywordWhenMatchingCampaigns
            },
        })
        // tslint:disable-next-line: no-any
        .then((results) => {
            if (results.data) {
                showNotification(null, 'Successfully submitted', 'info');  
                setState((_prevState) => {
                    return {
                        ..._prevState,
                        onSubmitLoading: false,
                        initialMandatoryFields: {
                            isLocationFieldMandatory: values.isLocationFieldMandatory,
                            isSourceNotesMandatory: values.isSourceNotesMandatory,
                            isInternalNotesMandatory: values.isInternalNotesMandatory,
                            isNatureOfEnquiryMandatory: values.isNatureOfEnquiryMandatory,
                            isEventAndCampaignMandatory: values.isEventAndCampaignMandatory,
                            isOtherSideNameMandatory: values.isOtherSideNameMandatory,
                            isEmailMandatory: values.isEmailMandatory,
                            isPhoneNumberMandatory: values.isPhoneNumberMandatory,
                            isMobileNumberMandatory: values.isMobileNumberMandatory,
                        }
                    };
                });   

                // reset the field and set to the current changes after saved.
                form.setConfig('keepDirtyOnReinitialize', false);
                form.batch(() => {
                    form.reset({
                        ...values,
                        showWarning: false
                    });
                });
                form.setConfig('keepDirtyOnReinitialize', true);
            }
        })
        // tslint:disable-next-line:no-any
        .catch((reason: any) => {
            showNotification('Failed to update enquiry default', reason, 'error');
            setState((_prevState) => {
                return {
                    ..._prevState,
                    onSubmitLoading: false
                };
            });
        });

    };

    const hasMandatoryFieldChanged = (values: FormState): boolean => {
        if (!state.initialMandatoryFields) return false;
        if (!state.initialMandatoryFields) return false;
        return mandatoryFieldNames.some(
            key => values[key] !== state.initialMandatoryFields![key]
        );
    };

    // Helper to check if any mandatory field is true
    const isAnyMandatoryTrue = (values: FormState): boolean => {
        return mandatoryFieldNames.some(key => values[key]);
    };

    const onSubmit = (form: FormApi<FormState>, values: FormState) => {

        const mandatoryChanged = hasMandatoryFieldChanged(values);
        const anyMandatoryTrue = isAnyMandatoryTrue(values);

        if (mandatoryChanged && anyMandatoryTrue) {
            form.change('showWarning', true);
            form.change('isMandatoryFieldChanged', true);
        } else {
            form.change('isMandatoryFieldChanged', false);
            onSave(form, values);
        }
    };

    const onDiscardChanges = (form: FormApi<FormState>, values: FormState) => (agree: boolean) => {
        if (agree) {
            onSave(form, values);

        }
        form.change('showWarning', false);
    };

    // tslint:disable-next-line: no-any
    const RadioComp = (compProps: any) => {

        const { input } = compProps;        
        return (
            <Radio
                {...input}
                checkedIcon={<RadioButtonCheckedIcon className={classes.radioIcon} />}
            />
        );
    };

    return (
        <> 
            <MuiPickersUtilsProvider utils={MomentUtils}>
                <div className={classes.root}>
                    {state.isLoading ? (
                        <SkeletonLoader variant="form" rows={8} columns={1} />
                    ) : (
                        <Form
                            onSubmit={(values, form: FormApi<FormState>) => onSubmit(form, values)}
                            initialValues={formState}
                            initialValuesEqual={() => true}
                            keepDirtyOnReinitialize={true}
                            subscription={{ submitting: true, pristine: true, values: true }}
                            validate={(values: FormState) => {
                                let errors = {
                                    addDays: '',
                                    addHours: '',
                                };

                                if (values.addDays && values.addDays < 0) {
                                    errors.addDays = 'Negative value is not allowed';
                                }

                                if (values.addHours && values.addHours < 0) {
                                    errors.addHours = 'Negative value is not allowed';
                                }

                                if (errors.addDays === '' && errors.addHours === '') {
                                    return undefined;
                                }

                                return errors;
                            }}
                            // debug={(values) => {
                            //     // tslint:disable-next-line: no-console
                            //     console.log('debug', values);
                            // }}
                            render={({ handleSubmit, form, submitting, pristine, values }) => (
                                <form onSubmit={handleSubmit}>
                                    <FormSpy
                                        subscription={{ pristine: true }}
                                        // tslint:disable-next-line: no-shadowed-variable
                                        onChange={(props) => {
                                            onFormValueChanged(props);
                                        }}
                                    />

                                    {values.showWarning && (
                                        <DialogBox
                                            title="Enquiry Warning"
                                            // tslint:disable-next-line:max-line-length
                                            content={`By setting these field(s) to mandatory, any existing records that do not contain values for them will need to be completed before they can be saved or updated.`}
                                            show={values.showWarning}
                                            isAgree={onDiscardChanges(form, values)}
                                            disAgreeLabel={'Cancel'}
                                            agreeLabel={'Save'}
                                            reverseActionsOrder={true}
                                        /> 
                                    )}

                                    <Grid container={true} spacing={3}>
                                        <Grid item={true} xs={12} md={12}>
                                            <CollapsibleSectionCard
                                                defaultExpanded={false}
                                                title="Due Dates Default"
                                                icon={EventIcon}
                                                color={SECTION_COLOR}
                                                bgColor={SECTION_BG}
                                            >
                                                    <Alert severity="info">All fields are optional. If none are provided, the RedView defaults are used</Alert>
                                                    <FormControl component="div" className={classes.formControl}>
                                                        <FormLabel component="legend">Due Date Options</FormLabel>
                                                        <RadioGroup className={classes.radioGroup}>
                                                            <FormControlLabel
                                                                control={<Field name="dueDateOption" component={RadioComp} type="radio" />}
                                                                value={'isManualEntry'}
                                                                label="Manual Entry"
                                                            />
                                                            <FormControlLabel
                                                                control={<Field name="dueDateOption" component={RadioComp} type="radio" />}
                                                                value={'isCalculatedDays'}
                                                                label="Calculated Days"
                                                            />
                                                            <FormControlLabel
                                                                control={<Field name="dueDateOption" component={RadioComp} type="radio" />}
                                                                value={'isCalculatedHours'}
                                                                label="Calculated Hours"
                                                            />
                                                        </RadioGroup>
                                                    </FormControl>
                                                    <FormSpy subscription={{ values: true, validating: true }}>
                                                        {/* tslint:disable-next-line: no-shadowed-variable */}
                                                        {({ values }) => (
                                                            <>
                                                                {values.dueDateOption === 'isManualEntry' && (
                                                                    <div className={classes.optionContainer}>
                                                                        <Field
                                                                            name="timeOfDay"
                                                                            allowNull={true}
                                                                            // validate={form.getFieldState('timeOfDay')?.value !== null ? required : undefined}
                                                                        >
                                                                            {({ input, meta }) => (
                                                                                <KeyboardTimePicker
                                                                                    {...input}
                                                                                    label="Default Time"
                                                                                    error={meta.error && meta.touched}
                                                                                    helperText={meta.error && meta.touched ? meta.error : ''}
                                                                                    size="small"
                                                                                    variant="inline"
                                                                                    keyboardIcon={<ScheduleIcon />}
                                                                                    InputLabelProps={{ shrink: true }}
                                                                                />
                                                                            )}
                                                                        </Field>
                                                                    </div>
                                                                )}
                                                                {values.dueDateOption === 'isCalculatedDays' && (
                                                                    <div className={classes.optionContainer}>
                                                                        <div className={classes.optionList}>
                                                                            <span className="text">Add</span>
                                                                            <Field name="addDays" allowNull={true}>
                                                                                {({ input, meta }) => (
                                                                                    <TextField
                                                                                        {...input}
                                                                                        label="Days"
                                                                                        error={meta.error && meta.touched}
                                                                                        helperText={meta.error && meta.touched ? meta.error : ''}
                                                                                        inputProps={{
                                                                                            pattern: '[0-9]*',
                                                                                        }}
                                                                                        type="number"
                                                                                        size="small"
                                                                                        variant="outlined"
                                                                                    />
                                                                                )}
                                                                            </Field>
                                                                            <span className="text">of working days to the current/time</span>
                                                                        </div>
                                                                        <div className={classes.optionList}>
                                                                            <span className="text">Optionally set time to </span>
                                                                            <Field
                                                                                name="timeOfDay"
                                                                                allowNull={true}
                                                                                // validate={form.getFieldState('timeOfDay')?.value !== null ? required : undefined}
                                                                            >
                                                                                {({ input, meta }) => (
                                                                                    <KeyboardTimePicker
                                                                                        {...input}
                                                                                        label="Time of day"
                                                                                        error={meta.error && meta.touched}
                                                                                        helperText={meta.error && meta.touched ? meta.error : ''}
                                                                                        size="small"
                                                                                        variant="inline"
                                                                                        InputLabelProps={{ shrink: true }}
                                                                                    />
                                                                                )}
                                                                            </Field>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                                {values.dueDateOption === 'isCalculatedHours' && (
                                                                    <div className={classes.optionContainer}>
                                                                        <div className={classes.optionList}>
                                                                            <span>Add</span>
                                                                            <Field
                                                                                name="addHours"
                                                                                allowNull={true}
                                                                                // validate={form.getFieldState('addHours')?.value !== null ? required : undefined}
                                                                            >
                                                                                {({ input, meta }) => (
                                                                                    <TextField
                                                                                        {...input}
                                                                                        label="hours"
                                                                                        error={meta.error && meta.touched}
                                                                                        helperText={meta.error && meta.touched ? meta.error : ''}
                                                                                        inputProps={{
                                                                                            pattern: '[0-9]*',
                                                                                        }}
                                                                                        type="number"
                                                                                        size="small"
                                                                                        variant="outlined"
                                                                                    />
                                                                                )}
                                                                            </Field>
                                                                            <span>to the current date/time</span>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </>
                                                        )}
                                                    </FormSpy>
                                            </CollapsibleSectionCard>
                                        </Grid>

                                        <Grid item={true} xs={12} md={12}>
                                            <CollapsibleSectionCard
                                                defaultExpanded={false}
                                                title="Follow Up Reminders"
                                                description="These fields define when reminders will be sent for enquiries."
                                                icon={NotificationsActiveIcon}
                                                color={SECTION_COLOR}
                                                bgColor={SECTION_BG}
                                            >
                                                    <Grid container={true} spacing={3}>
                                                        <Grid md={12} item={true}>
                                                            <div className={classes.optionWrapper}>
                                                                <div className={classes.optionContainer}>
                                                                    <div className={classes.optionList}>
                                                                        <span className="text">Set default reminder to</span>
                                                                        <Field
                                                                            name="reminder"
                                                                            allowNull={true}
                                                                            // validate={form.getFieldState('reminder')?.value !== null ? required : undefined}
                                                                        >
                                                                            {({ input, meta }) => (
                                                                                <ReminderSelector
                                                                                    {...input}
                                                                                    // label="Reminder"
                                                                                    className={classes.reminderTextField}
                                                                                    onSelection={(selection: IAutoCompleteItem) => {
                                                                                        input.onChange(selection);
                                                                                    }}
                                                                                    error={meta.error && meta.touched}
                                                                                    helperText={meta.error && meta.touched ? meta.error : ''}
                                                                                    size="small"
                                                                                />
                                                                            )}
                                                                        </Field>
                                                                        <span className="text">before follow up due</span>
                                                                    </div>
                                                                </div>
                                                                <div>
                                                                    <FormGroup className={classes.radioGroup}>
                                                                        <Field name="isSendReminderOnWeekend" subscription={{ touched: true, error: true, value: true }}>
                                                                            {({ input, meta }) => (
                                                                                <FormControlLabel
                                                                                    control={
                                                                                        <Checkbox
                                                                                            {...input}
                                                                                            checked={input.value}
                                                                                            onChange={input.onChange}
                                                                                            checkedIcon={<CheckBoxIcon color="primary" />}
                                                                                        />
                                                                                    }
                                                                                    label="Send on Weekends"
                                                                                />
                                                                            )}
                                                                        </Field>
                                                                    </FormGroup>
                                                                </div>
                                                            </div>
                                                        </Grid>
                                                        <Grid md={12} item={true}>
                                                            <div className={classes.optionWrapper}>
                                                                <div className={classes.optionContainer}>
                                                                    <div className={classes.optionList}>
                                                                        <span className="text">Send repeat reminders every</span>
                                                                        <Field
                                                                            name="overdueReminder"
                                                                            allowNull={true}
                                                                            // validate={form.getFieldState('overdueReminder')?.value !== null ? required : undefined}
                                                                        >
                                                                            {({ input, meta }) => (
                                                                                <ReminderSelector
                                                                                    {...input}
                                                                                    // label="Overdue Reminder"
                                                                                    className={classes.reminderTextField}
                                                                                    onSelection={(selection: IAutoCompleteItem) => {
                                                                                        input.onChange(selection);
                                                                                    }}
                                                                                    error={meta.error && meta.touched}
                                                                                    helperText={meta.error && meta.touched ? meta.error : ''}
                                                                                    size="small"
                                                                                    isNoZeroMinutes={true}
                                                                                />
                                                                            )}
                                                                        </Field>
                                                                        <span className="text">after follow up is due</span>
                                                                    </div>
                                                                </div>
                                                                <div>
                                                                    <FormGroup className={classes.radioGroup}>
                                                                        <Field
                                                                            name="isSendReminderOnWeekendForOverDueReminders"
                                                                            subscription={{ touched: true, error: true, value: true }}
                                                                        >
                                                                            {({ input, meta }) => (
                                                                                <FormControlLabel
                                                                                    control={
                                                                                        <Checkbox
                                                                                            {...input}
                                                                                            checked={input.value}
                                                                                            onChange={input.onChange}
                                                                                            checkedIcon={<CheckBoxIcon color="primary" />}
                                                                                        />
                                                                                    }
                                                                                    label="Send on Weekends"
                                                                                />
                                                                            )}
                                                                        </Field>
                                                                    </FormGroup>
                                                                </div>
                                                            </div>
                                                        </Grid>
                                                    </Grid>
                                            </CollapsibleSectionCard>
                                        </Grid>

                                        {UserFeature.HasAccess(UserFeatureEnum.hasEnquiryAutoFollowUp) ? (
                                            <Grid item={true} xs={12} md={12}>
                                                <CollapsibleSectionCard
                                                    defaultExpanded={false}
                                                    title="Auto Follow Up Defaults"
                                                    // tslint:disable-next-line:max-line-length
                                                    description="These fields define default settings for auto follow up processes. When used, an auto follow up will trigger the automatic sending of an email reminder to the enquirer, rather than sending a reminder to the assignee of the enquiry."
                                                    icon={AutorenewIcon}
                                                    color={SECTION_COLOR}
                                                    bgColor={SECTION_BG}
                                                >
                                                        <Grid container={true} spacing={3}>
                                                            <Grid md={12} item={true}>
                                                                <div className={classes.optionWrapper}>
                                                                    <div className={classes.optionContainer}>
                                                                        <div 
                                                                            className={classes.optionList}
                                                                            style={{
                                                                                alignItems: 'flex-end',
                                                                                gap: '10px',
                                                                            }}
                                                                        >
                                                                            <Field
                                                                                name="isAutoFollowUp"
                                                                                subscription={{ touched: true, error: true, value: true }}
                                                                            >
                                                                                {({ input, meta }) => (
                                                                                    <FormControlLabel
                                                                                        control={
                                                                                            <Checkbox
                                                                                                {...input}
                                                                                                checked={input.value}
                                                                                                onChange={input.onChange}
                                                                                                checkedIcon={<CheckBoxIcon color="primary" />}
                                                                                            />
                                                                                        }
                                                                                        label="Auto Follow Up"
                                                                                    />
                                                                                )}
                                                                            </Field>
                                                                            <Field
                                                                                name="autoFollowUpEmailTemplate"
                                                                                allowNull={true}
                                                                                // validate={form.getFieldState('reminder')?.value !== null ? required : undefined}
                                                                            >
                                                                                {({ input, meta }) => (
                                                                                    <EmailResponseTemplateSelector
                                                                                        {...input}
                                                                                        label="Email Template"
                                                                                        className={classes.emailTemplateTextField}
                                                                                        onSelection={(selection: IAutoCompleteItem) => {
                                                                                            input.onChange(selection);
                                                                                        }}
                                                                                        error={meta.error && meta.touched}
                                                                                        helperText={meta.error && meta.touched ? meta.error : ''}
                                                                                        size="small"
                                                                                    />
                                                                                )}
                                                                            </Field>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </Grid>

                                                        </Grid>
                                                </CollapsibleSectionCard>
                                            </Grid>
                                        ) : null}

                                        <Grid item={true} xs={12} md={12}>
                                            <CollapsibleSectionCard
                                                defaultExpanded={false}
                                                title="Unassigned Enquiry Notification"
                                                // tslint:disable-next-line:max-line-length
                                                description="These fields define when notifications will be sent for enquiries that remain unassigned. The delivery rules for the notifications are defined in Email Templates > Unassigned Enquiry Notification"
                                                icon={NotificationImportantIcon}
                                                color={SECTION_COLOR}
                                                bgColor={SECTION_BG}
                                            >
                                                    <Grid container={true} spacing={3}>
                                                        <Grid md={12} item={true}>
                                                            <div className={classes.optionWrapper}>
                                                                <div className={classes.optionContainer}>
                                                                    <div className={classes.optionList}>
                                                                        <span className="text">Send your notification</span>
                                                                        <Field
                                                                            name="periodBeforeFirstUnassignedReminder"
                                                                            allowNull={true}
                                                                            // validate={form.getFieldState('reminder')?.value !== null ? required : undefined}
                                                                        >
                                                                            {({ input, meta }) => (
                                                                                <ReminderSelector
                                                                                    {...input}
                                                                                    // label="Reminder"
                                                                                    className={classes.reminderTextField}
                                                                                    onSelection={(selection: IAutoCompleteItem) => {
                                                                                        input.onChange(selection);
                                                                                    }}
                                                                                    error={meta.error && meta.touched}
                                                                                    helperText={meta.error && meta.touched ? meta.error : ''}
                                                                                    size="small"
                                                                                />
                                                                            )}
                                                                        </Field>
                                                                        <span className="text">after remaining unassigned</span>
                                                                    </div>
                                                                </div>
                                                                <div>
                                                                    <FormGroup className={classes.radioGroup}>
                                                                        <Field name="isSendFistUnassignedReminderOnWeekends" subscription={{ touched: true, error: true, value: true }}>
                                                                            {({ input, meta }) => (
                                                                                <FormControlLabel
                                                                                    control={
                                                                                        <Checkbox
                                                                                            {...input}
                                                                                            checked={input.value}
                                                                                            onChange={input.onChange}
                                                                                            checkedIcon={<CheckBoxIcon color="primary" />}
                                                                                        />
                                                                                    }
                                                                                    label="Send on Weekends"
                                                                                />
                                                                            )}
                                                                        </Field>
                                                                    </FormGroup>
                                                                </div>
                                                            </div>
                                                        </Grid>
                                                        <Grid md={12} item={true}>
                                                            <div className={classes.optionWrapper}>
                                                                <div className={classes.optionContainer}>
                                                                    <div className={classes.optionList}>
                                                                        <span className="text">Send repeat reminders every</span>
                                                                        <Field
                                                                            name="periodAfterFirstUnassignedReminder"
                                                                            allowNull={true}
                                                                            // validate={form.getFieldState('overdueReminder')?.value !== null ? required : undefined}
                                                                        >
                                                                            {({ input, meta }) => (
                                                                                <ReminderSelector
                                                                                    {...input}
                                                                                    // label="Overdue Reminder"
                                                                                    className={classes.reminderTextField}
                                                                                    onSelection={(selection: IAutoCompleteItem) => {
                                                                                        input.onChange(selection);
                                                                                    }}
                                                                                    error={meta.error && meta.touched}
                                                                                    helperText={meta.error && meta.touched ? meta.error : ''}
                                                                                    size="small"
                                                                                    isNoZeroMinutes={true}
                                                                                />
                                                                            )}
                                                                        </Field>
                                                                        <span className="text">after the first notifications</span>
                                                                    </div>
                                                                </div>
                                                                <div>
                                                                    <FormGroup className={classes.radioGroup}>
                                                                        <Field
                                                                            name="isSendUnassignedAfterFirstReminderOnWeekends"
                                                                            subscription={{ touched: true, error: true, value: true }}
                                                                        >
                                                                            {({ input, meta }) => (
                                                                                <FormControlLabel
                                                                                    control={
                                                                                        <Checkbox
                                                                                            {...input}
                                                                                            checked={input.value}
                                                                                            onChange={input.onChange}
                                                                                            checkedIcon={<CheckBoxIcon color="primary" />}
                                                                                        />
                                                                                    }
                                                                                    label="Send on Weekends"
                                                                                />
                                                                            )}
                                                                        </Field>
                                                                    </FormGroup>
                                                                </div>
                                                            </div>
                                                        </Grid>
                                                    </Grid>
                                                </CollapsibleSectionCard>
                                        </Grid>

                                        {/* <Grid item={true} xs={12} md={12}>
                                                <Accordion
                                                    defaultExpanded={false}
                                                >
                                                    <AccordionSummary
                                                        expandIcon={<ExpandMoreIcon />}
                                                        aria-controls="panel1a-content"
                                                    >
                                                        <Typography className={classes.heading}>Follow Up Reminder Default</Typography>
                                                    </AccordionSummary>
                                                    <AccordionDetails className={classes.accordionDetails}>
                                                        <Grid container={true} spacing={3}>
                                                            <Grid md={12} item={true}>
                                                                <FormGroup className={classes.radioGroup}>
                                                                    <Field
                                                                        name="isSendReminderOnWeekend"
                                                                        subscription={{touched: true, error: true, value: true}}
                                                                    >                                            
                                                                        {({ input, meta }) => (
                                                                            <FormControlLabel
                                                                                control={
                                                                                    <Checkbox
                                                                                        {...input}
                                                                                        checked={input.value}
                                                                                        onChange={input.onChange}
                                                                                        checkedIcon={<CheckBoxIcon color="primary" />}
                                                                                    />
                                                                                }
                                                                                label="Send reminder on weekend" 
                                                                            />
                                                                        )}
                                                                    </Field>
                                                                </FormGroup>
                                                            </Grid>
                                                            <Grid md={12} item={true}>
                                                                <div className={classes.optionContainer}>
                                                                    <div className={classes.optionList}>
                                                                        <span className="text">Send reminder</span>
                                                                        <Field
                                                                            name="reminder"
                                                                            allowNull={true}
                                                                            // validate={form.getFieldState('reminder')?.value !== null ? required : undefined}
                                                                        >
                                                                            {({ input, meta }) => (
                                                                                <ReminderSelector
                                                                                    {...input}
                                                                                    // label="Reminder" 
                                                                                    className={classes.reminderTextField}
                                                                                    onSelection={(selection: IAutoCompleteItem) => {
                                                                                        input.onChange(selection);
                                                                                    }}
                                                                                    error={meta.error && meta.touched}
                                                                                    helperText={
                                                                                        meta.error &&
                                                                                        meta.touched
                                                                                            ? meta.error
                                                                                            : ''
                                                                                    }
                                                                                    size="small"
                                                                                />
                                                                            )}
                                                                        </Field>
                                                                        <span className="text">before follow up due</span>
                                                                    </div>
                                                                </div>
                                                            </Grid>
                                                        </Grid>
                                                    </AccordionDetails>
                                                </Accordion>
                                            </Grid> */}

                                        {/* <Grid item={true} xs={12} md={12}>
                                                <Accordion
                                                    defaultExpanded={false}
                                                >
                                                    <AccordionSummary
                                                        expandIcon={<ExpandMoreIcon />}
                                                        aria-controls="panel1a-content"
                                                    >
                                                        <Typography className={classes.heading}>Follow Up Overdue Reminder Default</Typography>
                                                    </AccordionSummary>
                                                    <AccordionDetails className={classes.accordionDetails}>
                                                        <Grid container={true} spacing={3}>
                                                            <Grid md={12} item={true}>
                                                                <FormGroup className={classes.radioGroup}>
                                                                    <Field
                                                                        name="isSendReminderOnWeekendForOverDueReminders"
                                                                        subscription={{touched: true, error: true, value: true}}
                                                                    >                                            
                                                                        {({ input, meta }) => (
                                                                            <FormControlLabel
                                                                                control={
                                                                                    <Checkbox
                                                                                        {...input}
                                                                                        checked={input.value}
                                                                                        onChange={input.onChange}
                                                                                        checkedIcon={<CheckBoxIcon color="primary" />}
                                                                                    />
                                                                                }
                                                                                label="Send reminder on weekend" 
                                                                            />
                                                                        )}
                                                                    </Field>
                                                                </FormGroup>
                                                            </Grid>
                                                            <Grid item={true} md={12}>
                                                                <div className={classes.optionContainer}>
                                                                    <div className={classes.optionList}>
                                                                        <span className="text">Send overdue reminder</span>
                                                                        <Field
                                                                            name="overdueReminder"
                                                                            allowNull={true}
                                                                            // validate={form.getFieldState('overdueReminder')?.value !== null ? required : undefined}
                                                                        >
                                                                            {({ input, meta }) => (
                                                                                <ReminderSelector
                                                                                    {...input}
                                                                                    // label="Overdue Reminder" 
                                                                                    className={classes.reminderTextField}
                                                                                    onSelection={(selection: IAutoCompleteItem) => {
                                                                                        input.onChange(selection);
                                                                                    }}
                                                                                    error={meta.error && meta.touched}
                                                                                    helperText={
                                                                                        meta.error &&
                                                                                        meta.touched
                                                                                            ? meta.error
                                                                                            : ''
                                                                                    }
                                                                                    size="small"
                                                                                    isNoZeroMinutes={true}
                                                                                />
                                                                            )}
                                                                        </Field>
                                                                        <span className="text">after follow up due</span>
                                                                    </div>
                                                                </div>
                                                            </Grid>
                                                        </Grid>
                                                    </AccordionDetails>
                                                </Accordion>
                                            </Grid> */}

                                        <Grid item={true} xs={12} md={12}>
                                            <CollapsibleSectionCard
                                                defaultExpanded={false}
                                                title="Meeting Defaults"
                                                icon={EventAvailableIcon}
                                                color={SECTION_COLOR}
                                                bgColor={SECTION_BG}
                                            >
                                                    <Grid container={true} spacing={3}>
                                                        <Grid md={12} item={true}>
                                                            <FormGroup className={classes.radioGroup}>
                                                                <Field name="isSendInvitationToAssignee" subscription={{ touched: true, error: true, value: true }}>
                                                                    {({ input, meta }) => (
                                                                        <FormControlLabel
                                                                            control={
                                                                                <Checkbox
                                                                                    {...input}
                                                                                    checked={input.value}
                                                                                    onChange={input.onChange}
                                                                                    checkedIcon={<CheckBoxIcon color="primary" />}
                                                                                />
                                                                            }
                                                                            label="Send confirmation email to staff member"
                                                                        />
                                                                    )}
                                                                </Field>
                                                                <Field name="isSendInvitationToEnquirer" subscription={{ touched: true, error: true, value: true }}>
                                                                    {({ input, meta }) => (
                                                                        <FormControlLabel
                                                                            control={
                                                                                <Checkbox
                                                                                    {...input}
                                                                                    checked={input.value}
                                                                                    onChange={input.onChange}
                                                                                    checkedIcon={<CheckBoxIcon color="primary" />}
                                                                                />
                                                                            }
                                                                            label="Send confirmation email to enquirer"
                                                                        />
                                                                    )}
                                                                </Field>
                                                            </FormGroup>
                                                        </Grid>
                                                        <Grid md={12} item={true}>
                                                            <div className={classes.optionContainer}>
                                                                <div className={classes.optionList}>
                                                                    <span className="text">Default meeting length</span>
                                                                    <Field
                                                                        name="defaultMeetingLength"
                                                                        allowNull={true}
                                                                        // validate={form.getFieldState('defaultMeetingLength')?.value !== null ? required : undefined}
                                                                    >
                                                                        {({ input, meta }) => (
                                                                            <KeyboardTimePicker
                                                                                {...input}
                                                                                error={meta.error && meta.touched}
                                                                                helperText={meta.error && meta.touched ? meta.error : ''}
                                                                                variant="inline"
                                                                                size="small"
                                                                                format="HH:mm"
                                                                                InputLabelProps={{ shrink: true }}
                                                                                ampm={false}
                                                                                keyboardIcon={<ScheduleIcon />}
                                                                                required={true}
                                                                            />
                                                                        )}
                                                                    </Field>
                                                                </div>
                                                            </div>
                                                            <div className={classes.optionContainer}>
                                                                <div className={classes.optionList}>
                                                                    <span className="text">Set default reminder to</span>
                                                                    <Field
                                                                        name="periodMeetingDefaultReminder"
                                                                        allowNull={true}
                                                                        // validate={form.getFieldState('defaultMeetingLength')?.value !== null ? required : undefined}
                                                                    >
                                                                        {({ input, meta }) => (
                                                                            <ReminderSelector
                                                                            {...input}
                                                                            className={classes.reminderTextField}
                                                                            onSelection={(selection: IAutoCompleteItem) => {
                                                                                input.onChange(selection);
                                                                            }}
                                                                            error={meta.error && meta.touched}
                                                                            helperText={meta.error && meta.touched ? meta.error : ''}
                                                                            size="small"
                                                                            isNoZeroMinutes={true}
                                                                        />
                                                                        )}
                                                                    </Field>
                                                                    <span>before meeting due</span>
                                                                </div>
                                                            </div>
                                                            <Grid md={12} item={true}>
                                                                <FormGroup className={classes.radioGroup}>
                                                                    <span className={classes.defaultMeetingLabel}>Default send reminder options: </span>
                                                                    <Field name="isSendMeetingDefaultReminderEmail" subscription={{ touched: true, error: true, value: true }}>
                                                                        {({ input, meta }) => (
                                                                            <FormControlLabel
                                                                                control={
                                                                                    <Checkbox
                                                                                        {...input}
                                                                                        checked={input.value}
                                                                                        onChange={input.onChange}
                                                                                        checkedIcon={<CheckBoxIcon color="primary" />}
                                                                                    />
                                                                                }
                                                                                label="Email"
                                                                            />
                                                                        )}
                                                                    </Field>
                                                                    {UserFeature.HasAccess(UserFeatureEnum.hasSmsIntegration) &&
                                                                    <Field name="isSendMeetingDefaultReminderSms" subscription={{ touched: true, error: true, value: true }}>
                                                                        {({ input, meta }) => (
                                                                            <FormControlLabel
                                                                                control={
                                                                                    <Checkbox
                                                                                        {...input}
                                                                                        checked={input.value}
                                                                                        onChange={input.onChange}
                                                                                        checkedIcon={<CheckBoxIcon color="primary" />}
                                                                                    />
                                                                                }
                                                                                label="SMS"
                                                                            />
                                                                        )}
                                                                    </Field>
                                                                    }
                                                                </FormGroup>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                            </CollapsibleSectionCard>
                                        </Grid>
                                        <Grid item={true} xs={12} md={12}>
                                            <CollapsibleSectionCard
                                                defaultExpanded={false}
                                                title="Mandatory Fields"
                                                icon={PlaylistAddCheckIcon}
                                                color={SECTION_COLOR}
                                                bgColor={SECTION_BG}
                                            >
                                                    <Grid container={true} spacing={3}>
                                                        <Grid md={12} item={true}>
                                                            <Alert severity="info">
                                                                Making fields mandatory will apply to existing enquiries. You will need to update existing enquiries to enter data in the newly mandatory field
                                                            </Alert>
                                                        </Grid>
                                                        <Grid md={12} item={true}>
                                                            <FormGroup className={classes.radioGroup}>
                                                                <Field name="isLocationFieldMandatory" subscription={{ touched: true, error: true, value: true }}>
                                                                    {({ input, meta }) => (
                                                                        <FormControlLabel
                                                                            control={
                                                                                <Checkbox
                                                                                    {...input}
                                                                                    checked={input.value}
                                                                                    onChange={input.onChange}
                                                                                    checkedIcon={<CheckBoxIcon color="primary" />}
                                                                                />
                                                                            }
                                                                            label="Location"
                                                                        />
                                                                    )}
                                                                </Field>

                                                                <Field name="isSourceNotesMandatory" subscription={{ touched: true, error: true, value: true }}>
                                                                    {({ input, meta }) => (
                                                                        <FormControlLabel
                                                                            control={
                                                                                <Checkbox
                                                                                    {...input}
                                                                                    checked={input.value}
                                                                                    onChange={input.onChange}
                                                                                    checkedIcon={<CheckBoxIcon color="primary" />}
                                                                                />
                                                                            }
                                                                            label="Source Notes"
                                                                        />
                                                                    )}
                                                                </Field>

                                                                <Field name="isInternalNotesMandatory" subscription={{ touched: true, error: true, value: true }}>
                                                                    {({ input, meta }) => (
                                                                        <FormControlLabel
                                                                            control={
                                                                                <Checkbox
                                                                                    {...input}
                                                                                    checked={input.value}
                                                                                    onChange={input.onChange}
                                                                                    checkedIcon={<CheckBoxIcon color="primary" />}
                                                                                />
                                                                            }
                                                                            label="Internal Notes"
                                                                        />
                                                                    )}
                                                                </Field>

                                                                <Field name="isEventAndCampaignMandatory" subscription={{ touched: true, error: true, value: true }}>
                                                                    {({ input, meta }) => (
                                                                        <FormControlLabel
                                                                            control={
                                                                                <Checkbox
                                                                                    {...input}
                                                                                    checked={input.value}
                                                                                    onChange={input.onChange}
                                                                                    checkedIcon={<CheckBoxIcon color="primary" />}
                                                                                />
                                                                            }
                                                                            label="Event and Campaign"
                                                                        />
                                                                    )}
                                                                </Field>

                                                                <Field name="isNatureOfEnquiryMandatory" subscription={{ touched: true, error: true, value: true }}>
                                                                    {({ input, meta }) => (
                                                                        <FormControlLabel
                                                                            control={
                                                                                <Checkbox
                                                                                    {...input}
                                                                                    checked={input.value}
                                                                                    onChange={input.onChange}
                                                                                    checkedIcon={<CheckBoxIcon color="primary" />}
                                                                                />
                                                                            }
                                                                            label="Nature of Enquiry"
                                                                        />
                                                                    )}
                                                                </Field>

                                                                <Field name="isEmailMandatory" subscription={{ touched: true, error: true, value: true }}>
                                                                    {({ input, meta }) => (
                                                                        <FormControlLabel
                                                                            control={
                                                                                <Checkbox
                                                                                    {...input}
                                                                                    checked={input.value}
                                                                                    onChange={input.onChange}
                                                                                    checkedIcon={<CheckBoxIcon color="primary" />}
                                                                                />
                                                                            }
                                                                            label="Email"
                                                                        />
                                                                    )}
                                                                </Field>

                                                                <Field name="isPhoneNumberMandatory" subscription={{ touched: true, error: true, value: true }}>
                                                                    {({ input, meta }) => (
                                                                        <FormControlLabel
                                                                            control={
                                                                                <Checkbox
                                                                                    {...input}
                                                                                    checked={input.value}
                                                                                    onChange={input.onChange}
                                                                                    checkedIcon={<CheckBoxIcon color="primary" />}
                                                                                />
                                                                            }
                                                                            label="Phone Number"
                                                                        />
                                                                    )}
                                                                </Field>

                                                                <Field name="isMobileNumberMandatory" subscription={{ touched: true, error: true, value: true }}>
                                                                    {({ input, meta }) => (
                                                                        <FormControlLabel
                                                                            control={
                                                                                <Checkbox
                                                                                    {...input}
                                                                                    checked={input.value}
                                                                                    onChange={input.onChange}
                                                                                    checkedIcon={<CheckBoxIcon color="primary" />}
                                                                                />
                                                                            }
                                                                            label="Mobile Number"
                                                                        />
                                                                    )}
                                                                </Field>

                                                                <Field name="isOtherSideNameMandatory" subscription={{ touched: true, error: true, value: true }}>
                                                                    {({ input, meta }) => (
                                                                        <FormControlLabel
                                                                            control={
                                                                                <Checkbox
                                                                                    {...input}
                                                                                    checked={input.value}
                                                                                    onChange={input.onChange}
                                                                                    checkedIcon={<CheckBoxIcon color="primary" />}
                                                                                />
                                                                            }
                                                                            label="Other Side Name"
                                                                        />
                                                                    )}
                                                                </Field>
                                                            </FormGroup>
                                                        </Grid>
                                                    </Grid>
                                            </CollapsibleSectionCard>
                                        </Grid>
                                        <Grid item={true} xs={12} md={12}>
                                            <CollapsibleSectionCard
                                                defaultExpanded={false}
                                                title="Digital Tracking"
                                                description="Choose which UTM parameters are used to match incoming enquiries to your events and campaigns."
                                                icon={TrackChangesIcon}
                                                color={SECTION_COLOR}
                                                bgColor={SECTION_BG}
                                            >
                                                    <FormSpy subscription={{ values: true }}>
                                                        {/* tslint:disable-next-line: no-shadowed-variable */}
                                                        {({ values }) => (
                                                            digitalTrackingParameters.every((parameter) => values[parameter.fieldName]) ? (
                                                                <Alert severity="warning" className={classes.trackingWarning}>
                                                                    No UTM parameters are selected, so enquiries will not be automatically matched to campaigns.
                                                                </Alert>
                                                            ) : null
                                                        )}
                                                    </FormSpy>
                                                    <div className={classes.trackingList}>
                                                        {digitalTrackingParameters.map((parameter, index) => (
                                                            <React.Fragment key={parameter.fieldName}>
                                                                {index > 0 && <Divider />}
                                                                <Field name={parameter.fieldName} subscription={{ value: true }}>
                                                                    {({ input }) => (
                                                                        <FormControlLabel
                                                                            className={classes.trackingRow}
                                                                            labelPlacement="start"
                                                                            classes={{ label: classes.trackingRowLabel }}
                                                                            control={
                                                                                <Switch
                                                                                    checked={!input.value}
                                                                                    onChange={(event) => input.onChange(!event.target.checked)}
                                                                                    color="primary"
                                                                                    inputProps={{ 'aria-label': `Match on ${parameter.label}` }}
                                                                                />
                                                                            }
                                                                            label={
                                                                                <>
                                                                                    <Typography variant="body1" className={classes.trackingRowTitle}>
                                                                                        {parameter.label}
                                                                                    </Typography>
                                                                                    <Typography variant="body2" className={classes.trackingRowDescription}>
                                                                                        {parameter.description}
                                                                                    </Typography>
                                                                                </>
                                                                            }
                                                                        />
                                                                    )}
                                                                </Field>
                                                            </React.Fragment>
                                                        ))}
                                                    </div>
                                            </CollapsibleSectionCard>
                                        </Grid>
                                        <Grid item={true} xs={12} md={12}>
                                            <CollapsibleSectionCard
                                                defaultExpanded={false}
                                                title="Enquiry Form Layout"
                                                description="Choose how many columns the enquiry form drawer shows when opening an existing enquiry."
                                                icon={ViewColumnIcon}
                                                color={SECTION_COLOR}
                                                bgColor={SECTION_BG}
                                            >
                                                    <Alert severity="info" className={classes.pageLayoutInfo}>
                                                        If the screen is not wide enough for the selected layout, the drawer automatically drops to fewer columns. New enquiries always open in a single column.
                                                    </Alert>
                                                    <Field name="pageLayout" allowNull={true} subscription={{ value: true }}>
                                                        {({ input }) => (
                                                            <div className={classes.pageLayoutOptionList} role="radiogroup" aria-label="Enquiry form layout">
                                                                {pageLayoutOptions.map((option) => {
                                                                    const isSelected = Number(input.value) === option.columnCount;
                                                                    return (
                                                                        <ButtonBase
                                                                            key={option.columnCount}
                                                                            role="radio"
                                                                            aria-checked={isSelected}
                                                                            className={clsx(classes.pageLayoutOption, isSelected && classes.pageLayoutOptionSelected)}
                                                                            onClick={() => input.onChange(option.columnCount)}
                                                                        >
                                                                            {isSelected && <CheckCircleIcon className={classes.pageLayoutSelectedIcon} />}
                                                                            <div className={classes.pageLayoutPreview}>
                                                                                {option.columnLabels.map((columnLabel) => (
                                                                                    <div
                                                                                        key={columnLabel}
                                                                                        className={clsx(classes.pageLayoutPreviewColumn, isSelected && classes.pageLayoutPreviewColumnSelected)}
                                                                                    >
                                                                                        <span className={classes.pageLayoutPreviewLabel}>{columnLabel}</span>
                                                                                        <span className={classes.pageLayoutPreviewLine} />
                                                                                        <span className={clsx(classes.pageLayoutPreviewLine, classes.pageLayoutPreviewLineShort)} />
                                                                                        <span className={classes.pageLayoutPreviewLine} />
                                                                                    </div>
                                                                                ))}
                                                                            </div>
                                                                            <Typography variant="body1" className={classes.pageLayoutOptionTitle}>
                                                                                {option.title}
                                                                            </Typography>
                                                                            <Typography variant="body2" className={classes.pageLayoutOptionDescription}>
                                                                                {option.description}
                                                                            </Typography>
                                                                            <Typography variant="caption" className={classes.pageLayoutScreenRequirement}>
                                                                                <DesktopWindowsIcon className={classes.pageLayoutScreenRequirementIcon} />
                                                                                {option.screenRequirement}
                                                                            </Typography>
                                                                        </ButtonBase>
                                                                    );
                                                                })}
                                                            </div>
                                                        )}
                                                    </Field>
                                            </CollapsibleSectionCard>
                                        </Grid>
                                        {/* {printJson(values)} */}
                                    </Grid>
                                    <Divider className={classes.actionsDivider} />
                                    <div className={classes.actionsRow}>
                                        <Button variant="text" color="default" type="button" disabled={submitting || pristine} onClick={onReset(form)}>
                                            Reset
                                        </Button>
                                        <Button variant="contained" color="primary" type="submit" disabled={submitting || pristine || state.onSubmitLoading}>
                                            Save
                                        </Button>
                                    </div>
                                </form>
                            )}
                        />
                    )}
                </div>
            </MuiPickersUtilsProvider>
        </>
    );
}

// tslint:disable-next-line: no-any
// export function printJson(values: any) {
//     if (values) {
//         return (
//             <>
//                 <pre>
//                     {JSON.stringify(values, undefined, 2)}
//                 </pre>
//             </>
//         );
//     } else {
//         return (
//             <>
//                 <FormSpy subscription={{ values: true }}>
//                     {/* tslint:disable-next-line: no-shadowed-variable */}
//                     {({ values }) => (
//                         <pre>
//                             {JSON.stringify(values, undefined, 2)}
//                             {/* <RenderCount /> */}
//                         </pre>
//                     )}
//                 </FormSpy>
//             </>
//         );
//     }
// }
